export default __webpack_public_path__ + "static/media/navbar-icon-users.58342d7d.svg";